import React, {useEffect, useState} from "react";
import { Formik, Field, FormikActions, ErrorMessage } from "formik";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { Actions as appActions } from "reducers/app";

import TextField from "components/TextField";
import { IClientData } from "./components/Result";
import VinResult from "./components/VinResult";

import * as API from "api/vinCheck";
import {Link} from "react-router-dom";
import RecommendProducts from "pages/VinCheck/components/RecommendProducts";

interface ISearchParams {
  Vin: string;
  brandId?: string;
  modelSeriesId?: string;
  custName?: string;
  PIN?: string;
  polis?: string;
  plate?: string;
}

interface ISpinner {
  toggleUIBlocking: (payload: boolean) => void;
}

const VinCheck: React.FC<ISpinner> = ({ toggleUIBlocking }) => {
  const [foundClient, setFoundClient] = useState<IClientData | undefined>(
    undefined
  );
  const [commonProducts, setCommonProducts] = useState([]);

  const clearedForm = {
    Vin: "",
    brandId: "",
    modelSeriesId: "",
    custName: "",
    PIN: "",
    polis: "",
    plate: ""
  };

  const [initialValues, setInitialValues] = useState<ISearchParams>(
    clearedForm
  );

  useEffect(() => {
    API.getCommonProducts()
      .then((response) => {
        const {success, data, error} = response;

        if (success) {
          setCommonProducts(data);
        } else {
          toastr.error(error, "");
        }
      })
  }, []);

  const submit = (
    values: ISearchParams,
    { setSubmitting }: FormikActions<ISearchParams>
  ) => {
    toggleUIBlocking(true);
    setInitialValues(values);
    API.vinCheck({ ...values }).then((response: any) => {
      if (response.success) {
        setFoundClient(response.data);
      } else {
        toastr.error(response.error, "");
      }
      toggleUIBlocking(false);
      setSubmitting(false);
    });
  };

  const handleReturnToSearch = () => {
    setFoundClient(undefined);
  };

  const formValidate = ({ Vin, custName, PIN}: ISearchParams) => {
    let errors: { [key: string]: string } = {};

    // TODO: write proper validation
    if (Vin || custName || PIN) {
      return;
    } else {
      errors.Vin = "Заполните одно из полей: Vin, ФИО, PIN";
      errors.custName = "error";
      errors.PIN = "error";
    }
    return errors;
  };

  return (
    <React.Fragment>
      {!foundClient ? (
        <div className="container">
          <div className="row">
            <div className="vin m-auto bug_20_top___ col-12 col-lg-6">
              <h2 className="vin__title">Проверка VIN</h2>
              <Formik
                initialValues={initialValues}
                onSubmit={submit}
                validate={formValidate}
                render={({
                           submitForm,
                           handleReset,
                           resetForm,
                           setFieldValue,
                           values
                         }) => (
                  <div className="form-row">
                    <div
                      style={{ height: "25px", textAlign: "left", width: "100%" }}
                    >
                    <span className="invalid">
                      <ErrorMessage name="Vin" />
                    </span>
                    </div>
                    <div className="form-group col-12">
                      <label htmlFor="#input1">VIN номер*</label>
                      <Field
                        id="input1"
                        name="Vin"
                        component={TextField}
                        onChange={(e: any) => {
                          const val = e.target.value;
                          const newValue = !/^[\d\w*]{0,17}$/.test(val)
                            ? values.Vin
                            : val;
                          setFieldValue("Vin", newValue);
                        }}
                      />
                    </div>
                    <div className="form-group col-12">
                      <label htmlFor="#input4">ФИО клиента*</label>
                      <Field id="input4" name="custName" component={TextField} />
                    </div>
                    <div className="form-group col-12">
                      <label htmlFor="#input5">ПИН</label>
                      <Field id="input5" name="PIN" component={TextField} />
                    </div>
                    <div className="form-group col-12">
                      <label htmlFor="#input2">Госномер</label>
                      <Field id="input2" name="plate" component={TextField} />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label htmlFor="#input6">Марка авто</label>
                      <Field id="input6" name="brandId" component={TextField} />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <label htmlFor="#input7">Модель авто</label>
                      <Field id="input5" name="modelSeriesId" component={TextField} />
                    </div>
                    <div className="form-group col-12 d-md-flex justify-content-between mt-3 mt-md-0">
                      <button
                        className="btn btn-grey px-0 py-0"
                        onClick={() => resetForm(clearedForm)}
                      >
                        Очистить данные
                      </button>
                      <button
                        className="btn px-0 py-0 d-md-inline ml-2"
                        onClick={submitForm}
                      >
                        Проверить VIN
                      </button>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col-12 col-lg-6 prod recommend-products__prod">
              <div className="row w-100 mx-0 d-flex justify-content-between align-items-center kost">
                <div className="prod__title">
                  Рекомендуемые товары
                  {/* <br className="d-md-none" /> для клиента */}
                </div>
                <Link to={"/home/catalog"}><button className="btn px-0 py-0 d-md-block">
                  Все товары
                </button></Link>
              </div>
              <div className="row w-100 no-gutters recommend-product">
                <RecommendProducts recommendProducts={commonProducts} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <VinResult onChange={handleReturnToSearch} {...foundClient} />
      )}
    </React.Fragment>
  );
};

const actions = {
  toggleUIBlocking: appActions.toggleUIBlocking
};

export default connect(
  null,
  actions
)(VinCheck);
